// Helpers for the user-drawer field editor (UserDetailsPopup).
//
// Member consent settings must not be editable from the admin panel at all.
// The member sets these themselves from consent-worded UI in the app, and the
// admin drawer's generic editor could only ever corrupt them: typing "false"
// used to write the STRING "false" (readers test `=== false`, so the member
// read as opted IN), and Delete removes the field (absent means default-on).
// Either way the only reachable outcome was silently revoking an opt-out.
export const MEMBER_CONSENT_FIELDS = new Set(["gistAiMemoryEnabled"]);

export function isMemberConsentField(field) {
  return MEMBER_CONSENT_FIELDS.has(field);
}

// Why the drawer's "+ Add field" override refuses a key, or null when it can be
// saved. The override writes whatever key the operator types, so without this a
// consent field was still one typed name away (GIS-256). Returned as text the
// drawer shows inline, so the refusal is visible rather than a Save that does
// nothing.
export function overrideFieldKeyError(key) {
  const trimmed = String(key ?? "").trim();
  if (isMemberConsentField(trimmed)) {
    return `${trimmed} is the member's own setting. Only they can change it, from the app.`;
  }
  return null;
}

// Parse a value typed into the drawer's plain-text field editor.
// Booleans must round-trip: a doc value `false` renders as "false" in the
// input, so saving it unchanged has to write the boolean back, not a string.
export function parseFieldValue(raw) {
  const trimmed = String(raw).trim();
  const lower = trimmed.toLowerCase();
  if (lower === "true") return true;
  if (lower === "false") return false;
  if (trimmed !== "" && !isNaN(Number(trimmed))) return Number(trimmed);
  return trimmed;
}
